import React, { FunctionComponent, PropsWithChildren } from 'react';
import { FullscreenCircularProgress } from '../components/FullscreenCircularProgress';

export const RouteSuspense: FunctionComponent<PropsWithChildren> = ({ children }) => {
  return <React.Suspense fallback={<FullscreenCircularProgress />}>{children}</React.Suspense>;
};
